(function (Lfl, $, undefined) {
    if (Lfl.Files.isLoadedAlready(Lfl, 'Number')) {
        return;
    }

    /*
     |==============================================================================================================
     | Documentation
     |==============================================================================================================
     */

    /**
     * @memberOf Lfl
     */
    Lfl.Number = Lfl.Number || {};

    (function (Number, $, undefined) {

        /*
         |===========================================================================================================
         | Object definition
         |===========================================================================================================
         */

        /*
         |-----------------------------------------------------------------------------------------------------------
         | Public methods
         |-----------------------------------------------------------------------------------------------------------
         */

        /**
         * Is the given variable a number or a string containing only a number?
         *
         * Source: https://stackoverflow.com/a/35759874/5500468
         * @memberOf Lfl.Number
         * @return {boolean}
         */
        Number.isNumber = function (variable) {
            if (typeof variable == 'number') {
                return true;
            }

            if (typeof variable != "string") {
                return false;
            }

            return !isNaN(variable) && !isNaN(parseFloat(variable))
        };

    }(Lfl.Number = Lfl.Number || {}, jQuery));
}(window.Lfl = window.Lfl || {}, jQuery));
